export default __webpack_public_path__ + "static/media/element_29.ae431ad5.avif";